import React, { FC, useState, useEffect } from 'react';
import { Block, Icon, Text } from '@/presentation/components';
import warningAlertIcon from '../../../../../assets/icons/warning-alert.svg';
import ContainerProcedure from '@/presentation/modules/procedures/components/ContainerProcedure';
import { SubContainer } from '@/presentation/modules/procedures/modules/certificates-constancies/type1/info/components';
import { BackButton } from '@/presentation/modules/procedures/components';
import Spinner from '@/presentation/components/Spinner';
import TextHelper from '@/core/helpers/TextHelper';
import {
  Card,
  CardContent,
  CardHeader,
  CertificationsContainer,
  CourseGradesContainer,
  DownloadButton,
  StateCourseIcon,
  StateIcon,
  FlexContainer,
  IconContainer,
  WarningIcon,
  ToggleButton,
  CourseInfoContainer,
  CourseGrade,
  Divider,
  CourseStateContainer
} from './styled';
import { useCourseStyles } from './hooks/useCourseStyles';
import downloadIcon from '../../../../../assets/icons/courses/progressiveCertification/icon-download.svg';

interface IProps {
  handlerBack: any;
  isLoading: any;
  certifications: {
    certificationId: string;
    certificateCode: string;
    certificationName: string;
    state: string;
    message: string;
    courses: {
      courseId: string;
      courseName: string;
      finalGrade: number | null;
      state: string;
    }[];
  }[];
  handleDownload: (certificationId?: string) => Promise<void>;
}

const ProgressiveCertificationsView: FC<IProps> = ({
  handlerBack,
  isLoading,
  certifications,
  handleDownload
}) => {
  const [openIds, setOpenIds] = useState<string[]>([]);
  const { getCourseStateText } = useCourseStyles();

  const toggle = (id: string) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((openId) => openId !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    if (certifications && certifications.length > 0) {
      setOpenIds(certifications.map((cert) => cert.certificationId));
    }
  }, [certifications]);
  return (
    <ContainerProcedure>
      <SubContainer style={{ marginBottom: 12 }}>
        <Block
          customized
          width="100%"
          display="flex"
          justifyContent="flex-start"
          padding="16px 0 0 0"
        >
          <BackButton onClick={handlerBack} fontSize="14px" />
        </Block>
      </SubContainer>
      <SubContainer>
        <Block customized padding=" 0 0 16px 0">
          <Text fontWeight="700" fontSize="24px" lineHeight="32px">
            Certificaciones progresivas
          </Text>
        </Block>
      </SubContainer>
      {isLoading ? (
        <Spinner />
      ) : (
        <SubContainer>
          <Block
            customized
            backgroundColor="#d5e5f0"
            borderRadius="8px"
            gap="8px"
            flexDirection="row"
            padding="16px"
            margin="0 0 12px 0"
          >
            <IconContainer>
              <WarningIcon src={warningAlertIcon} alt="warningAlertIcon" />
            </IconContainer>
            <Text
              fontWeight="400"
              fontSize="14px"
              lineHeight="20px"
              color="#161D1F"
            >
              Debes alcanzar la nota mínima de 14 en todos los cursos para
              obtener el certificado.
            </Text>
          </Block>
          <CertificationsContainer>
            {certifications?.map((cert) => (
              <Card key={cert.certificationId}>
                <CardHeader onClick={() => toggle(cert.certificationId)}>
                  <FlexContainer gap="xs">
                    <div className="icons">
                      <StateIcon state={cert.state} />
                    </div>
                    <div>
                      <span className="title">{cert.certificationName}</span>
                    </div>
                  </FlexContainer>
                  <ToggleButton type="button">
                    <Icon
                      name={
                        openIds.includes(cert.certificationId)
                          ? 'chevron-up'
                          : 'chevron-down'
                      }
                      size={24}
                      color="#5B36F2"
                    />
                  </ToggleButton>
                </CardHeader>

                {openIds.includes(cert.certificationId) && (
                  <CardContent>
                    <CourseGradesContainer>
                      {cert.courses.map((course, index) => (
                        <React.Fragment key={course.courseId}>
                          <div>
                            <div className="course-name">
                              {TextHelper.fixRomans(
                                TextHelper.capitalize(
                                  course.courseName,
                                  false,
                                  true
                                )
                              )}
                            </div>
                            <CourseInfoContainer>
                              <CourseGrade>
                                Nota:{' '}
                                {course.finalGrade !== null
                                  ? course.finalGrade
                                  : '--'}
                              </CourseGrade>
                              <Divider orientation="vertical" />
                              <CourseStateContainer state={course.state}>
                                <StateCourseIcon state={course.state} />
                                {getCourseStateText(course.state as any)}
                              </CourseStateContainer>
                            </CourseInfoContainer>
                          </div>
                          {index < cert.courses.length - 1 && (
                            <Divider orientation="horizontal" />
                          )}
                        </React.Fragment>
                      ))}
                    </CourseGradesContainer>
                    <p className="message">{cert.message}</p>
                    {cert.state === 'COMPLETED' && (
                      <DownloadButton
                        onClick={() => handleDownload(cert.certificateCode)}
                      >
                        <img src={downloadIcon} alt="Descargar" />
                        <span>Descargar certificado</span>
                      </DownloadButton>
                    )}
                  </CardContent>
                )}
              </Card>
            ))}
          </CertificationsContainer>
        </SubContainer>
      )}
    </ContainerProcedure>
  );
};

export default ProgressiveCertificationsView;
